<div class="select-category">
  {{ category }}
</div>

<ng-content></ng-content>
